import { useSyncExternalStore } from "react";
import { appUpdater } from "../pwa/register";

/** Shown when a new version has been downloaded; applying it is always the user's choice. */
export function UpdateBanner() {
  const available = useSyncExternalStore(
    (listener) => appUpdater.subscribe(listener),
    () => appUpdater.updateAvailable,
  );
  if (!available) return null;
  return (
    <div className="banner" role="status">
      <span>A new version of codescreen is available.</span>
      <button type="button" onClick={() => void appUpdater.applyUpdate()}>
        Refresh to update
      </button>
    </div>
  );
}
